{
  "sube": {
    "Baslik": "Şube Tanıtımı",
    "Ad": "Ad",
    "Merkez": "Merkez Mi",
    "Durum": "Durum",
    "Arama": "Arama",
    "Ara": "Ara",
    "Temizle": "Temizle",
    "Kapat": "Kapat",
    "Yenile": "Yenile",
    "Data Yenile": "Verileri Güncelle",
    "Ekle": "Şube Ekle",
    "Filtrele": "Filtrele",
    "Duzenle": "Düzenle",
    "Sil": "Sil",
    "Kaydet": "Kaydet",
    "Guncelle": "Güncelle",
    "Vazgec": "Vazgeç",
    "Latitude": "Enlem (Lat)",
    "Longitude": "Boylam (Long)",
    "Şube Tanıtım": "Şube Tanıtımı"
  }
}
